export default __webpack_public_path__ + "static/media/3.f31af0f6.svg";